var map = {
	"./ad.svg": "TO62",
	"./admin.svg": "dwv9",
	"./adsort.svg": "fq9y",
	"./apps.svg": "bFcS",
	"./city.svg": "aOYn",
	"./config.svg": "c2mF",
	"./configgroup.svg": "5Ouk",
	"./dep.svg": "PgRM",
	"./dic.svg": "qfQC",
	"./dictype.svg": "HzBR",
	"./home.svg": "5COo",
	"./item.svg": "d4Tv",
	"./itemcate.svg": "F87A",
	"./layout.svg": "bbao",
	"./layoutdesc.svg": "9ehA",
	"./level.svg": "LNO/",
	"./link.svg": "Q/KX",
	"./menu.svg": "f9hy",
	"./permission.svg": "IiPh",
	"./position.svg": "dsU5",
	"./role.svg": "D6NU",
	"./user.svg": "Km1V",
	"./userlevel.svg": "VOQz"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "/tJe";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons nonrecursive \.svg$
// module id = /tJe
// module chunks = 7